import { useState } from 'react';

import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';

import {
  verifiableCredentialTypenameToCertsyType,
  type VerificationsSeekPassDialogAnalyticsOrigin,
} from '../analyticsUtils';
import type { VerifiableCredentialTypename } from '../types';

import { VerifyDigitalIdDialog } from './VerifyDigitalIdDialog';
import { VerifyLicenceDialog } from './VerifyLicenceDialog';
import { VerifyWorkHistoryDialog } from './VerifyWorkHistoryDialog';

interface Props {
  typename: VerifiableCredentialTypename;
  url: string;
  origin: VerificationsSeekPassDialogAnalyticsOrigin;
  dialogTitle?: string;
  trackingEntityName?: string;
}

export const useVerificationDialog = ({
  typename,
  dialogTitle,
  url,
  origin,
  trackingEntityName,
}: Props) => {
  const [showDialog, setShowDialog] = useState(false);

  const { seekPassDialogClicked } = useAnalytics();

  const onSeekPassDialogClick = ({
    callToAction,
  }: {
    callToAction: 'verify on certsy' | 'maybe later';
  }) => {
    const certsyType = verifiableCredentialTypenameToCertsyType[typename];
    seekPassDialogClicked({
      certsyType,
      callToAction,
      origin,
      entityName: trackingEntityName,
    });
  };

  const dialogProps = {
    url,
    showDialog,
    closeDialogFn: () => setShowDialog(false),
    dialogTitle,
    origin,
    onSeekPassDialogClick,
    trackingEntityName,
  };

  const verificationToDialog: Record<
    VerifiableCredentialTypename,
    JSX.Element
  > = {
    IdentityVerifiableCredential: <VerifyDigitalIdDialog {...dialogProps} />,
    WorkplaceVerifiableCredential: <VerifyWorkHistoryDialog {...dialogProps} />,
    LicenceVerifiableCredential: <VerifyLicenceDialog {...dialogProps} />,
  };

  const dialog = verificationToDialog[typename];

  return {
    dialog,
    setShowDialog,
  };
};
